import styled from 'foundations-theming/utils';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';

// @bend-expect trellis-tokenized
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PanelSectionWrapper = styled.div.withConfig({
  displayName: "PanelSection__PanelSectionWrapper"
})(["margin-top:-1px;border-top:1px solid ", ";"], ({
  theme
}) => theme.color['border-core-subtle']);
export const PanelSection = ({
  title,
  showBorders = true,
  children
}) =>
/*#__PURE__*/
// @bend-expect trellis-tokenized
_jsxs(PanelSectionWrapper, {
  children: [/*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    borderColor: "border-core-subtle",
    borderStyle: showBorders ? 'solid' : 'none',
    borderWidth: showBorders ? '100' : '0',
    paddingBlock: "300",
    paddingInline: "500",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h7",
      children: title
    })
  }), children]
});
export default PanelSection;